module.exports = __webpack_public_path__ + "static/media/recommendation-box.e9dd0dd2.png";